import { render, staticRenderFns } from "./ElMenuLinksV4.vue?vue&type=template&id=7d4cae62"
import script from "./ElMenuLinksV4.vue?vue&type=script&lang=js"
export * from "./ElMenuLinksV4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports